import { Carousel } from '@mantine/carousel';
import { ProductItem } from './ProductItem';
import { ContentfulProduct } from '@web/common';
import { observer } from 'mobx-react';
import classes from './Product.module.css';

export const ProductCarousel = observer(
  ({
    filteredProducts,
    selectedProductType,
  }: {
    filteredProducts: ContentfulProduct[];
    selectedProductType: string;
  }) => {
    return (
      <Carousel
        key={selectedProductType} // This will reset the carousel when filter changes
        slideSize={{ base: '30%', md: '20%', lg: '20%' }}
        slideGap={{ base: 'sm', md: 'md', lg: 'md' }}
        withIndicators
        align="start"
        classNames={classes}
      >
        {filteredProducts.map((product) => (
          <Carousel.Slide key={product.sys.id}>
            <ProductItem data={product} />
          </Carousel.Slide>
        ))}
      </Carousel>
    );
  },
);
